import React from 'react'
import { useNavigate } from 'react-router-dom'
import WTPAssignMainWorkCard from './WTPAssignedMaintainanceWorkCard'
import { useAuthState } from '../../../../../Helper/Context'

export default function WTPAssignMainWorkCardManage(props) {
    const { Countdata, HeaderMonthID, HeaderFinancialYear, MonthValue, YearValue, YearLabel, MonthLabel, WardValue, WardLabel, ProjectTypeId, DashboardName, DashProjectTypeId, WTPMasterCountData } = props
    const navigate = useNavigate()

    const userDetails = useAuthState();
    const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth } = userDetails
    const { UserID, token, RoleID } = userDetails.user

    const WTPAssignMainWorkCardNavigate1 = (name, screenFlag) => {
        if (name === "Operation Pending") {
            navigate(`/Commonwtpassignedmaintainanceworkdatapage?ScreenName=Operational Works - Pending&name=${name}&ApiFlag=OperationPending&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        } else if (name === "Operation Completed") {
            navigate(`/Commonwtpassignedmaintainanceworkdatapage?ScreenName=Operational Works - Completed&name=${name}&ApiFlag=OperationCompleted&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        }
        else if (name === "Electric Pending") {
            navigate(`/Commonwtpassignedmaintainanceworkdatapage?ScreenName=Electrical Work - Pending&name=${name}&ApiFlag=ElectricalPending&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        }
        else if (name === "Electric Completed") {
            navigate(`/Commonwtpassignedmaintainanceworkdatapage?ScreenName=Electrical Work - Completed&name=${name}&ApiFlag=ElectricalCompleted&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        }
        else if (name === "Mechanical Pending") {
            navigate(`/Commonwtpassignedmaintainanceworkdatapage?ScreenName=Mechanical Work - Pending&name=${name}&ApiFlag=MechanicalPending&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        }
        else if (name === "Mechanical Completed") {
            navigate(`/Commonwtpassignedmaintainanceworkdatapage?ScreenName=Mechanical Work - Completed&name=${name}&ApiFlag=MechanicalCompleted&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        }
        else if (name === "Civil Pending") {
            navigate(`/Commonwtpassignedmaintainanceworkdatapage?ScreenName=Civil Work - Pending&name=${name}&ApiFlag=CivilPending&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        }
        else if (name === "Civil Completed") {
            navigate(`/Commonwtpassignedmaintainanceworkdatapage?ScreenName=Civil Work - Completed&name=${name}&ApiFlag=CivilCompleted&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        }
    }

    return (
        <div>
            <div className="row">
                <h5 className="ml-4 py-2">Assigned Maintenance Work</h5>
            </div>
            <div className="row pr-3 pl-3">
                <div className="col-12 col-md-6 col-lg-3 mb-2">
                    <WTPAssignMainWorkCard
                        title="Operation Works"
                        title1="Operation Pending"
                        cardName='py-1 wwork_img cursor'
                        imgPath='./assets/img/completed1.png'
                        imgPathsecond='./assets/img/pending.png'
                        countPending={WTPMasterCountData?.OperationalWorksPendingTotalCount ? WTPMasterCountData?.OperationalWorksPendingTotalCount : '0'}
                        WTPAssignMainWorkCardNavigate1={WTPAssignMainWorkCardNavigate1}
                        cardHeading='Operational Works'
                        title2="Operation Completed"
                        searchNametitle2="OperationCompleted"
                        countCompleted={WTPMasterCountData?.OperationalWorksCompletedTotalCount ? WTPMasterCountData?.OperationalWorksCompletedTotalCount : '0'}

                    />

                </div>

                <div className="col-12 col-md-6 col-lg-3 mb-2">
                    <WTPAssignMainWorkCard
                        title="Electrical Work Maintenance"
                        title1="Electric Pending"
                        cardName='py-1 wwork_img cursor'
                        imgPath='./assets/img/completed1.png'
                        imgPathsecond='./assets/img/pending.png'
                        countPending={WTPMasterCountData?.ElectricalWorkPendingTotalCount ? WTPMasterCountData?.ElectricalWorkPendingTotalCount : '0'}
                        // navLink='/preventivecommondata'
                        WTPAssignMainWorkCardNavigate1={WTPAssignMainWorkCardNavigate1}
                        cardHeading='Electrical Work'
                        title2="Electric Completed"
                        searchNametitle2="ElectricCompleted"
                        countCompleted={WTPMasterCountData?.ElectricalWorkCompletedTotalCount ? WTPMasterCountData?.ElectricalWorkCompletedTotalCount : '0'}

                    />
                </div>

                <div className="col-12 col-md-6 col-lg-3 mb-2">
                    <WTPAssignMainWorkCard
                        title="Mechanical Work Maintainance"
                        title1="Mechanical Pending"
                        cardName='py-1 wwork_img cursor'
                        imgPath='./assets/img/completed1.png'
                        imgPathsecond='./assets/img/pending.png'
                        countPending={WTPMasterCountData?.MechanicalWorkPendingTotalCount ? WTPMasterCountData?.MechanicalWorkPendingTotalCount : '0'}
                        // navLink='/preventivecommondata'
                        WTPAssignMainWorkCardNavigate1={WTPAssignMainWorkCardNavigate1}
                        cardHeading='Mechanical Work'
                        title2="Mechanical Completed"
                        searchNametitle2="CivilCompleted"
                        countCompleted={WTPMasterCountData?.MechanicalWorkCompletedTotalCount ? WTPMasterCountData?.MechanicalWorkCompletedTotalCount : '0'}

                    />
                </div>

                <div className="col-12 col-md-6 col-lg-3 mb-2">
                    <WTPAssignMainWorkCard
                        title="Civil Work Maintenance"
                        title1="Civil Pending"
                        cardName='py-1 wwork_img cursor'
                        imgPath='./assets/img/completed1.png'
                        imgPathsecond='./assets/img/pending.png'
                        countPending={WTPMasterCountData?.CivilWorkPendingTotalCount ? WTPMasterCountData?.CivilWorkPendingTotalCount : '0'}
                        // navLink='/preventivecommondata'
                        WTPAssignMainWorkCardNavigate1={WTPAssignMainWorkCardNavigate1}
                        cardHeading='Civil Work'
                        title2="Civil Completed"
                        searchNametitle2="CivilCompleted"
                        countCompleted={WTPMasterCountData?.CivilWorkCompletedTotalCount ? WTPMasterCountData?.CivilWorkCompletedTotalCount : '0'}

                    />
                </div>

            </div>
        </div>
    )

}
